export default {
  getQuoteAttachment: (state) => state.quoteAttachment,
};
